module.exports = __webpack_public_path__ + "img/hoslogo16.20de82a3.png";